import { render, staticRenderFns } from "./RatingRecords.vue?vue&type=template&id=275b440a&scoped=true"
import script from "./RatingRecords.vue?vue&type=script&lang=js"
export * from "./RatingRecords.vue?vue&type=script&lang=js"
import style0 from "./RatingRecords.vue?vue&type=style&index=0&id=275b440a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b440a",
  null
  
)

export default component.exports